import { render, staticRenderFns } from "./ActivitySelectionPopup.vue?vue&type=template&id=a52fb2e8&scoped=true"
import script from "./ActivitySelectionPopup.vue?vue&type=script&lang=js"
export * from "./ActivitySelectionPopup.vue?vue&type=script&lang=js"
import style0 from "./ActivitySelectionPopup.vue?vue&type=style&index=0&id=a52fb2e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52fb2e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a52fb2e8')) {
      api.createRecord('a52fb2e8', component.options)
    } else {
      api.reload('a52fb2e8', component.options)
    }
    module.hot.accept("./ActivitySelectionPopup.vue?vue&type=template&id=a52fb2e8&scoped=true", function () {
      api.rerender('a52fb2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/ActivitySelectionPopup.vue"
export default component.exports